var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstablished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3196_45258)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C2.79086 1 1 2.79086 1 5V9C1 11.2091 2.79086 13 5 13H9C11.2091 13 13 11.2091 13 9V5C13 2.79086 11.2091 1 9 1H5ZM10.832 4.55481C11.1384 4.09528 11.0142 3.47441 10.5547 3.16806C10.0952 2.8617 9.47429 2.98588 9.16793 3.44541L5.99998 8.19733L4.83203 6.44541C4.52568 5.98588 3.90481 5.8617 3.44528 6.16806C2.98576 6.47441 2.86158 7.09528 3.16793 7.55481L5.16793 10.5548C5.3534 10.833 5.66563 11.0001 5.99998 11.0001C6.33434 11.0001 6.64657 10.833 6.83203 10.5548L10.832 4.55481Z",
    fill: "#19A66B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3196_45258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablished);
export default __webpack_public_path__ + "static/media/Established.184ba6ee965d90aa4fb01c52cc0bde6e.svg";
export { ForwardRef as ReactComponent };